import styled from 'styled-components';
import { css } from '@emotion/core';
import { MD_SCREEN_MIN } from '../../modules/Styleguide';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .labelWrapper {
    margin-bottom: 10px;
  }
`;

export const PseudoLabel = styled.span`
  margin-bottom: 10px;
  color: #292f36;
  font-weight: 500;
  font-size: 1.6rem;
  font-style: normal;
  line-height: 2rem;
`;

export const DropdownWrapper = styled.div`
  @media (max-width: ${MD_SCREEN_MIN}px) {
    width: 100%;
  }
`;

export const Dropdown = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 210px;
  height: 46px;
  padding-right: 16px;
  padding-left: 16px;
  border-radius: 6px;
  background-color: #dfe0e1;
  @media (max-width: ${MD_SCREEN_MIN}px) {
    width: 100%;
  }
  &:hover {
    background-color: #d4d5d7;
  }
  &:active {
    background-color: #c9cbcd;
  }
`;

export const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 378px;
  margin: 0 auto;
`;

export const PublishDateDisplay = styled.p`
  color: #5f6369;
  font-weight: bold;
  font-size: 1.6rem;
  line-height: 2rem;
`;

export const LocalTimezoneMessage = styled.p`
  color: #7f8287;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.6rem;
`;

export const DatetimeGlobalStyles = css`
  .DatetimeContainer {
    .rdtCounters {
      display: inline-flex;
      align-items: center;
      height: 258px;
    }
    .rdtCount,
    .rdtCounterSeparator {
      font-weight: normal;
    }
    .rdtCount {
      height: 25%;
    }
    .rdtBtn {
      color: #c9cbcd;
    }
    .rdtPicker {
      width: 100%;
      margin: 0;
      padding: 0;
      border: 2px solid rgba(201, 203, 205, 0.2);
      border-radius: 6px;
    }
    tfoot {
      border-top: 2px solid rgba(201, 203, 205, 0.2);
    }
    .rdtSwitch {
      padding: 14px;
      font-size: 18px;
    }
    .rdtPrev,
    .rdtNext {
      vertical-align: middle !important;
    }
    .rdtPrev span,
    .rdtNext span {
      color: #c9cbcd;
      font-size: 32px;
    }
    .rdtTimeToggle {
      padding: 10px;
      font-size: 18px;
    }
    .dow {
      color: #5f6369;
      font-weight: normal;
      font-size: 14px;
    }
    .rdtDay {
      height: 32px;
      font-weight: normal;
      font-size: 16px;
    }
    .rdtDay:hover {
      background: transparent;
    }
    .rdtMonth,
    .rdtYear {
      height: 86px;
    }
    .rdtActive {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: auto;
      border-radius: 100%;
      color: white;
      font-weight: bold;
      background: #5000b9 !important;
    }
    .rdtDay.rdtActive {
      width: 30px;
      height: 30px;
    }
    .rdtMonth.rdtActive,
    .rdtYear.rdtActive {
      width: 60px;
      height: 60px;
      margin: 13px 0px 13px 17px;
    }
  }
`;
